const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the file uploader component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('fileUploader', [function () {
  return {
    restrict: 'E',
    scope: {
      file: '=',
      accept: '@',
      setId: '@'
    },
    template: '<input id="{{setId}}" type="file" file="file" accept="{{accept}}" required />',
    link: function (scope, el, attrs) {
      el.bind('change', function (event) {
        var file = event.target.files[0];
        scope.file = file ? file : undefined;
        scope.$apply();
      });
    }
  };
}]);